<template>
<div class="excursionInner">
    <div>Тип: {{props.excursion.type}}</div>
    <div>
        <div v-if="props.excursion.included">Включено в стоимость</div>
        <div v-else>
            Оплачивается отдельно.
            <div v-if="adl_price(props.excursion) || chi_price(props.excursion)">
                Стоимость составляет
                <span v-if="adl_price(props.excursion)"><PriceCurrencyV :price="adl_price(props.excursion)" :sum="true" /> за взрослого, </span>
                <span v-if="chi_price(props.excursion)"><PriceCurrencyV :price="chi_price(props.excursion)" :sum="true" /> за ребенка</span>
            </div>
        </div>
    </div>
    <div>Продолжительность: {{humanizeDuration(props.excursion.length)}}</div>
</div>
</template>

<style lang="scss">
.excursionInner {margin-bottom: 20px;}
</style>

<script setup>
import {ref,unref} from 'vue'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'
import {humanizeDuration} from '@/util.js'

/*

excursion - использую эти атрибуты
        "id": 61858,
        "name": "– «Автобусная обзорная экскурсия по Казани с посещением Кремля и Собора Казанской иконы Божией Матери»",
        "type": "Автобусная",
        "description": "<p style=\"text-align: justify;\">В ходе ...</p>,
        "length": "04:00:00",
        "included": 1,

У цены такие:
"priceAdult": 500,
"priceAdultCurrency": 1,
"priceChild": 400,
"priceChildCurrency": 1,
*/


const props = defineProps({
    excursion: Object,
})

const adl_price = ({priceAdult, priceAdultCurrency}) => {
    let ret = null
    if (priceAdult) {
        ret = {v: [priceAdult, priceAdultCurrency]}
    }
    return ret
}
const chi_price = ({priceChild, priceChildCurrency}) => {
    let ret = null
    if (priceChild) {
        ret = {v: [priceChild, priceChildCurrency]}
    }
    return ret
}
</script>
